"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pngjs_1 = require("pngjs");
var packbits_1 = require("@fiahfy/packbits");
var icns_1 = require("./icns");
var BitmapBuilder = /** @class */ (function () {
    function BitmapBuilder(png, osType, format) {
        this.png = png;
        this.osType = osType;
        this.format = format;
    }
    BitmapBuilder.prototype.build = function () {
        switch (this.format) {
            case 'MASK':
                return this.mask;
            case 'RGB':
                return this.rgb;
            case 'ARGB':
                return this.argb;
            default:
                return undefined;
        }
    };
    Object.defineProperty(BitmapBuilder.prototype, "mask", {
        get: function () {
            return this.getChannel(3);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BitmapBuilder.prototype, "rgb", {
        get: function () {
            // the "it32" data seams to be offset by 4 bytes
            // @see https://gist.github.com/raweden/1065894#file-icnsencoder-as-L63
            var offset = this.osType === 'it32' ? 4 : 0;
            var header = Buffer.alloc(offset);
            return Buffer.concat([
                header,
                packbits_1.encode(this.getChannel(0), { format: 'icns' }),
                packbits_1.encode(this.getChannel(1), { format: 'icns' }),
                packbits_1.encode(this.getChannel(2), { format: 'icns' })
            ]);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BitmapBuilder.prototype, "argb", {
        get: function () {
            var header = Buffer.alloc(4);
            header.write('ARGB', 0, 4, 'ascii');
            return Buffer.concat([
                header,
                packbits_1.encode(this.getChannel(3), { format: 'icns' }),
                packbits_1.encode(this.getChannel(0), { format: 'icns' }),
                packbits_1.encode(this.getChannel(1), { format: 'icns' }),
                packbits_1.encode(this.getChannel(2), { format: 'icns' })
            ]);
        },
        enumerable: true,
        configurable: true
    });
    BitmapBuilder.prototype.getChannel = function (index) {
        var data = [];
        for (var i = 0; i < this.png.data.length; i += 4) {
            data.push(this.png.data.slice(index + i, index + i + 1));
        }
        return Buffer.concat(data);
    };
    return BitmapBuilder;
}());
exports.BitmapBuilder = BitmapBuilder;
var IcnsImage = /** @class */ (function () {
    function IcnsImage(osType, bytes, image) {
        if (osType === void 0) { osType = 'ic10'; }
        if (bytes === void 0) { bytes = 8; }
        if (image === void 0) { image = Buffer.alloc(0); }
        this.osType = osType;
        this.bytes = bytes;
        this.image = image;
    }
    /**
     * Create ICNS image from the buffer.
     * @param buffer The ICNS image buffer.
     */
    IcnsImage.from = function (buffer) {
        var osType = buffer.toString('ascii', 0, 4);
        var bytes = buffer.readUInt32BE(4);
        var image = buffer.slice(8, bytes);
        return new IcnsImage(osType, bytes, image);
    };
    /**
     * Create ICNS Image from the PNG image buffer.
     * @param buffer The PNG image buffer.
     * @param osType The icon OSType.
     */
    IcnsImage.fromPNG = function (buffer, osType) {
        var iconType = icns_1.Icns.supportedIconTypes.find(function (iconType) { return iconType.osType === osType; });
        if (!iconType) {
            throw new TypeError('No supported osType');
        }
        var png = IcnsImage.readPNG(buffer);
        if (!png) {
            throw new TypeError('Image must be PNG format');
        }
        var width = png.width;
        var height = png.height;
        if (width !== height) {
            throw new TypeError('Image must be squre');
        }
        if (width !== iconType.size) {
            throw new TypeError("Image size must be " + iconType.size + "x" + iconType.size + " for '" + osType + "'");
        }
        var image = iconType.format === 'PNG'
            ? buffer
            : new BitmapBuilder(png, osType, iconType.format).build();
        if (!image) {
            throw new TypeError("Invalid format '" + iconType.format + "'");
        }
        var bytes = 8 + image.length;
        return new IcnsImage(osType, bytes, image);
    };
    Object.defineProperty(IcnsImage.prototype, "data", {
        get: function () {
            var buffer = Buffer.alloc(8);
            buffer.write(this.osType, 0, 4, 'ascii');
            buffer.writeUInt32BE(this.bytes, 4);
            return Buffer.concat([buffer, this.image]);
        },
        enumerable: true,
        configurable: true
    });
    IcnsImage.readPNG = function (buffer) {
        try {
            return pngjs_1.PNG.sync.read(buffer);
        }
        catch (e) {
            return undefined;
        }
    };
    return IcnsImage;
}());
exports.IcnsImage = IcnsImage;
